const autoNgTemplateLoaderTemplate1 = require('./networkMacvlanForm.html');

angular.module('shbdeployer.docker').component('networkMacvlanForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'NetworkMacvlanFormController',
  bindings: {
    data: '=',
    applicationState: '<',
  },
});
